<template>
	<div class="lock">
		<indexHeader></indexHeader>
		<div class="account-wrap">
			<div class="inback">
				<div>
					<span>{{$t('iesan.b_wabao')}}</span>
				</div>
				<div class="text">{{$t('iesan.b_jiandan')}}</div>
				<img class="in" src="../../static/imgs/backimg.jpg">
			</div>
			<div class="comfirm-modal flex" v-show="comfirmShow">
				<div class="comfirm-modal-content">
					<div class="loss-modal-header">
						<h3>USDT{{$t('iesan.b_cung')}}</h3>
						<p @click="closeMosal()">X</p>
					</div>
					<ul>
						<li class="flex">
							<p>{{$t('iesan.b_shouyi')}}：</p>
							<p>{{alterdata.rate}} %</p>
						</li>
						<li class="flex">
							<p>{{$t('iesan.b_zhiyao')}}：</p>
							<p>{{alterdata.number}} USDT</p>
						</li>
						<li class="flex">
							<p>{{$t('iesan.b_yuji')}}：</p>
							<p>{{alterdata.day * alterdata.rate * 0.01 * alterdata.number  | toFixed8}} USDT</p>
						</li>
						<li class="flex">
							<p>{{$t('iesan.b_qianbao')}}：</p>
							<p>{{change_balance}} USDT</p>
						</li>
					</ul>
					<div class="modal-btn">
						<button type="button" @click="closeMosal()">{{$t('iesan.b_quxiao')}}</button>
						<button type="button" @click="comfirm()">{{$t('iesan.b_goumai')}}</button>
					</div>
				</div>
			</div>
			<div class="account">
				<div class="accountcontent mineCardList">
					<div class="mineCard" v-for="(item,index) in newList" :key="index">
						<div class="topName">
							<div class="topNamePay ft18">USDT{{$t('iesan.b_zhjuanbi')}}</div>
						</div>
						<div class="acbuyBtmL  mt10 flex between"
							style="background: rgb(245, 245, 245); padding: 10px 15px; margin: 10px 15px 0px;">
							<input v-model="item.number" :placeholder="$t('iesan.b_num') + item.money" type="" name="" id=""
								value="" />
							<span>USDT</span>
						</div>
						<div class="acbuyBtmL  mt5 flex between">
							<em>{{$t('iesan.b_yuji')}}</em>
						</div>
						<div class="acbuyBtmL  mt5 flex between" style="margin: 10px 15px 0px;">
							<!-- day * rate * 0.01 * 你输入的数量 -->
							<em class="em">{{item.day * item.rate * 0.01 * item.number  | toFixed8}}</em>
							<span>
								USDT
							</span>
						</div>
						<div class="bottomCard flex between alcenter">
							<div class="midType ">
								<div class="price">
									{{item.rate}}% <span>[USDT]</span>
								</div>
								<div class="midTypetTitle gray9">
									{{$t('iesan.b_jin')}}3{{$t('iesan.b_rinianhua')}} <span>[USDT]</span>
								</div>
							</div>
							<div class="midDay">
								<div>{{item.day}}{{$t('iesan.b_tian')}}</div>
								<span class="gray9">{{$t('iesan.b_suochang')}}</span>
							</div>
						</div>
						<div class="minerBtn flex between alcenter">
							<div class="btn" @click="submit(item)">
								{{$t('iesan.b_gtou')}}
							</div>
						</div>
					</div>
				</div>
				<div class="acbox bg-part">
					<div class="acrecordTitle">{{$t('iesan.b_jilu')}}</div>
					<div class="acrecordList pd20">
						<div class="acrecordListTitle">
							<span>{{$t('iesan.b_biaohuao')}}</span>
							<span>{{$t('iesan.b_bizhong')}}</span>
							<span>{{$t('iesan.b_shuliang')}}</span>
							<span>{{$t('iesan.b_jixi')}}</span>
							<span>{{$t('iesan.b_suocang')}}</span>
							<span>{{$t('iesan.b_shijan')}}</span>
							<span>{{$t('iesan.b_zhuangtai')}}</span>
						</div>
						<div class="acrecordListTxt">
							<div v-for="(item,index) in listdata" :key="index + 'q'">
								<span>{{item.id}}</span>
								<span>{{item.from_name}}</span>
								<span>{{item.money}} USDT</span>
								<span>{{item.interest}} USDT</span>
								<span>{{item.created_at}}</span>
								<span>{{item.complete_at}}</span>
								<span v-if="item.status == '进行中'">{{$t('iesan.b_jinxin')}}</span>
								<span v-if="item.status == '已结束'">{{$t('iesan.b_jieshu')}}</span>
							</div>
						</div>
						<div class="sharemore" @click="share()">{{more}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import indexHeader from "@/view/indexHeader";
	export default {
		name: "noticeList",
		components: {
			indexHeader
		},
		data() {
			return {
				newList: [],
				comfirmShow: false,
				change_balance: '',
				alterdata: {},
				listdata: [],
				page: 1,
				limit: 10,
				more: this.$t('iesan.b_genduo')
			};
		},
		filters: {
			toFixed8: function(value) {
				value = Number(value);
				return value.toFixed(8);
			},
			toFixed6: function(value) {
				value = Number(value);
				return value.toFixed(6);
			}
		},
		created() {
			var that = this;
			that.getorder();
			that.lists(1);
		},
		mounted() {},
		methods: {
			share(){
				this.page++
				this.lists(1);
			},
			lists(e){
				console.log("lists")
				if(e == 2){
					this.page = 1;
					this.listdata = [];
				}
				let data = this.alterdata;
				let page = this.page;
				let limit = this.limit;
				this.$http({
					url: '/api/lockorder/lists?page=' + page + '&limit=' + limit,
					method: 'get',
					data: {},
					headers: {'Authorization':  localStorage.getItem('token')},
				}).then(res => {
					console.log(res.data)
					if(res.data.message.length > 1){
						this.listdata = this.listdata.concat(res.data.message);
						this.more = this.$t('iesan.b_genduo');
					}else{
						this.more = this.$t('iesan.b_mei');
					}
				});
			},
			closeMosal(){
				this.comfirmShow = false;
			},
			comfirm(){
				let data = this.alterdata;
				this.$http({
					url: '/api/lockorder/submit',
					method: 'post',
					data: {
						id: data.id,
						number: data.number,
					},
					headers: {'Authorization':  localStorage.getItem('token')},
				}).then(res => {
					this.comfirmShow = false;
					this.lists(2);
					layer.msg(res.data.message);
				});
			},
			submit(e) {
				if(e.number < parseInt(e.money)){
					layer.msg(this.$t('iesan.b_zhenqui'));
					return
				}
				let id = e.id;
				let _this = this;
				this.$http({
					url: '/api/lockorder/wallet?id=' + id,
					method: 'get',
					data: {},
					headers: {'Authorization':  localStorage.getItem('token')},
				}).then(res => {
					_this.change_balance = res.data.message.change_balance;
					_this.alterdata = e;
					_this.comfirmShow = true;
				});
			},
			getorder() {
				this.$http({
					url: '/api/lockorder/getorder',
					method: 'get',
					data: {},
					headers: {
						'Authorization': localStorage.getItem('token')
					},
				}).then(res => {
					this.newList = res.data.message;
				})
			},
		},
	};
</script>
<style lang="scss" scoped>
	.mt5 {
		margin: 10px 15px 0px;
	}

	.comfirm-modal {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		justify-content: center;
		align-items: center;
		color: #c7cce6;
	}

	.comfirm-modal-content {
		width: 500px;
		background-color: #1a243b;
		margin: 0 auto;
		border-radius: 5px;
	}

	.loss-modal-header {
		line-height: 40px;
		text-align: center;
		position: relative;
	}

	.loss-modal-header p {
		position: absolute;
		right: 10px;
		top: 0;
	}

	.comfirm-modal-content li {
		line-height: 40px;
		margin: 0 20px;
	}

	.modal-btn {
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		font-size: 0;
		padding-top: 30px;
	}

	.modal-btn button {
		width: 50%;
		line-height: 50px;
		border: none;
		float: left;
		font-size: 14px;
		color: #fff;
		background: #9db5c7;
	}

	.modal-btn button:last-child {
		border-left: 1px solid #2e333c;
		background: #689cf1;
	}

	.lock {
		.acbox {
			color: #FFFFFF;
			margin: 40px 0;
			background-color: #1a243b;

			.acrecordTitle {
				padding: 15px 20px;
				border-bottom: 1px solid #e6ecf2;
			}

			.acrecordList {
				.acrecordListTitle {
					display: flex;
					flex-direction: row;

					span {
						width: 100%;
						padding: 10px 20px;
						background-color: rgba(13, 168, 139, .1);
						color: #0da88b;
						margin-right: 5px;
					}
				}

				.acrecordListTxt div:nth-child(2n) span {
					background-color: rgba(242, 246, 250, .5);
				}

				.acrecordListTxt {
					div {
						margin-top: 10px;
						display: flex;
						flex-direction: row;

						span {
							text-align: center;
							padding: 10px 5px;
							margin-right: 5px;
							width: 100%;
						}
					}
				}

				.sharemore {
					margin: 20px 0 0;
					text-align: center;
					cursor: pointer;
				}
			}

			.pd20 {
				padding: 20px 0;
			}
		}

		.account-wrap {
			.inback {
				width: 100%;
				height: 230px;
				position: relative;
				box-sizing: border-box;
				padding-top: 60px;

				div {
					text-align: center;
					justify-content: center;
					position: relative;

					span {
						position: relative;
						background: #ffd12d;
						color: #000;
						font-weight: 700;
						padding: 5px 15px;
						border-radius: 15px;
						font-size: 14px;
					}
				}


				span:after {
					content: "";
					position: absolute;
					bottom: -8px;
					left: 18px;
					border-width: 0 10px 10px;
					border-style: solid;
					border-color: transparent transparent transparent #ffd12d;
				}

				.text {
					color: #FFFFFF;
					font-weight: 700;
					text-align: center;
					font-size: 30px;
					color: #fff;
					margin-top: 40px;
				}

				img {
					position: absolute;
					left: 0;
					top: 0;
					z-index: -1;
					width: 100%;
					height: 230px;
				}
			}

			.account {
				width: 1200px;
				margin: 40px auto;
				margin-bottom: 0;
				padding-top: 30px;
				overflow: hidden;
				padding-top: 0;
				// min-height: 880px;

				.accountcontent {
					width: 100%;
					// min-height: 800px;
				}

				.mineCardList {
					color: #000;
					margin-right: 4%;
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;

					.mineCard {
						// position: relative;
						width: 48%;
						margin-top: 20px;
						border-radius: 15px;
						background-color: #fff;
						padding-top: 20px;
						padding-bottom: 20px;
						color: #000;
						margin-right: 2%;

						.topName {
							font-size: 28px;
							display: flex;
							flex-direction: column;
							padding-left: 15px;

							.topNamePay {
								color: #000;
								margin-top: 10px;
								font-weight: 700;
							}
						}

						.acbuyBtmL {
							input {
								background: transparent;
								width: 80%;
								max-width: 80%;
							}

							.em {
								font-style: normal;
								font-weight: bold;
							}
						}

						.bottomCard {
							padding: 0 20px;

							.midType {
								margin-top: 20px;

								.price {
									letter-spacing: 3px;
									font-size: 25px;
									font-weight: 700;
									color: #00b796;

									span {
										font-size: 16px;
									}
								}

								.midTypetTitle {
									font-size: 15px;
									margin-bottom: 20px;
								}
							}

							.gray9 {
								color: #999;
							}

							.midDay {
								display: flex;
								flex-direction: column;

								div {
									margin-bottom: 5px;
									font-size: 25px;
									font-weight: 700;
									color: #000;
								}
							}
						}

						.minerBtn {
							margin: 0 20px;

							.btn {
								width: 100%;
								padding: 12px 40px;
								text-align: center;
								font-size: 14px;
								color: #fff;
								background-color: #2c63e4;
								border-radius: 5px;
								box-sizing: border-box;
								cursor: pointer;
							}
						}

					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/lock.vue